import React from 'react';

const Path = ({ description }) => {
  return (
    <div className="path">
      <div className="container">
        <div className="path__content">
          <span className="path__slash">/</span>
          <span className="path__description">{description}</span>
        </div>
      </div>
    </div>
  );
};

export default Path;
